import { locale } from '../lib/locale';

/**
 * Stars, rewards, approvals, family moments and the pinboard (1.19). Glossary: Familienziel =
 * family goal, Familienmoment = family moment. German is the master.
 */
export const STARS_TEXT = {
  de: {
    goal: 'Familienziel',
    goalLabel: (title: string) => `Familienziel ${title}`,
    goalValue: (progress: string, target: string) => `${progress} von ${target} Sternen`,
    goalStars: (progress: string, target: string) => `${progress} / ${target} Sterne`,
    kids: 'Kinder',
    progressTo: (name: string, goal: string) => `${name}: Fortschritt zu ${goal}`,
    ofCost: (balance: string, cost: string) => `${balance} von ${cost}`,
    target: 'Ziel:',
    moment: 'Familienmoment',
    moments: 'Familienmomente',
    view: (name: string) => `${name} ansehen`,
    rewardsFor: (name: string) => `Belohnungen für ${name}`,
    tapName: 'Oben auf deinen Namen tippen, um Belohnungen einzulösen.',
    stars: 'Sterne',
    // reward shop
    noRewards: 'Noch keine Belohnungen – Eltern legen sie über „＋“ oder in den Einstellungen an.',
    has: (name: string) => `${name} hat`,
    free: 'frei',
    reserved: (n: string) => ` – ${n} sind für Anfragen reserviert`,
    requested: 'Angefragt – Mama oder Papa schauen gleich.',
    withdraw: 'Zurückziehen',
    earnMore: (missing: string, unit: string) => `Noch ${missing} ${unit} – zu den Aufgaben`,
    redeem: 'Einlösen',
    redeemAsk: (title: string) => `${title} einlösen?`,
    costs: 'Das kostet',
    thenLeft: '. Danach bleiben',
    parentsApprove: 'Mama oder Papa bekommen die Anfrage und geben sie frei.',
    cancel: 'Abbrechen',
    yesAsk: 'Ja, anfragen',
    failed: 'Das hat nicht geklappt. Bitte nochmal versuchen.',
    momentFor: (name: string) => `Familienmoment für ${name}`,
    kudosPresets: [
      'hat geholfen',
      'hat geteilt',
      'war mutig',
      'hat getröstet',
      'hat ohne Erinnerung angepackt',
    ],
    parentMode: 'Das hat nicht geklappt. Ist der Elternmodus noch aktiv?',
    send: 'Senden – erscheint an der Wand',
    // approvals
    task: 'Aufgabe',
    reward: 'Belohnung',
    failedShort: 'Das hat nicht geklappt.',
    waitingForYou: 'Wartet auf dich',
    approveAll: 'Alle freigeben',
    nothingWaiting: 'Nichts wartet auf dich.',
    wants: 'möchte',
    notNow: 'Nicht jetzt',
    again: 'Nochmal',
    // pinboard
    pinboard: 'Pinnwand',
    editNote: 'Zettel ändern',
    change: 'Ändern',
    reallyRemove: 'Wirklich abnehmen',
    remove: 'Abnehmen',
    removedForAll: 'Abgenommene Zettel verschwinden für alle.',
    whoPins: 'Abnehmen können Mama, Papa, die Großen und wer den Zettel angepinnt hat.',
    onlyToday: 'nur heute',
    untilTomorrow: 'bis morgen',
    until: (day: string) => `bis ${day}`,
  },
  en: {
    goal: 'Family goal',
    goalLabel: (title: string) => `Family goal ${title}`,
    goalValue: (progress: string, target: string) => `${progress} of ${target} stars`,
    goalStars: (progress: string, target: string) => `${progress} / ${target} stars`,
    kids: 'Kids',
    progressTo: (name: string, goal: string) => `${name}: progress towards ${goal}`,
    ofCost: (balance: string, cost: string) => `${balance} of ${cost}`,
    target: 'Goal:',
    moment: 'Family moment',
    moments: 'Family moments',
    view: (name: string) => `See ${name}`,
    rewardsFor: (name: string) => `Rewards for ${name}`,
    tapName: 'Tap your name at the top to redeem rewards.',
    stars: 'Stars',
    noRewards: 'No rewards yet – parents add them via “＋” or in Settings.',
    has: (name: string) => `${name} has`,
    free: 'to spend',
    reserved: (n: string) => ` – ${n} are held for requests`,
    requested: 'Requested – Mum or Dad will take a look soon.',
    withdraw: 'Withdraw',
    earnMore: (missing: string, unit: string) => `${missing} more ${unit} – go to tasks`,
    redeem: 'Redeem',
    redeemAsk: (title: string) => `Redeem ${title}?`,
    costs: 'That costs',
    thenLeft: '. Afterwards you’ll have',
    parentsApprove: 'Mum or Dad get the request and approve it.',
    cancel: 'Cancel',
    yesAsk: 'Yes, ask',
    failed: 'That didn’t work. Please try again.',
    momentFor: (name: string) => `Family moment for ${name}`,
    kudosPresets: [
      'helped out',
      'shared',
      'was brave',
      'comforted someone',
      'got stuck in without a reminder',
    ],
    parentMode: 'That didn’t work. Is parent mode still on?',
    send: 'Send – shows up on the wall',
    task: 'Task',
    reward: 'Reward',
    failedShort: 'That didn’t work.',
    waitingForYou: 'Waiting for you',
    approveAll: 'Approve all',
    nothingWaiting: 'Nothing is waiting for you.',
    wants: 'would like',
    notNow: 'Not now',
    again: 'Try again',
    pinboard: 'Pinboard',
    editNote: 'Edit note',
    change: 'Edit',
    reallyRemove: 'Take down for good',
    remove: 'Take down',
    removedForAll: 'Notes you take down disappear for everyone.',
    whoPins: 'Mum, Dad, the older kids and whoever pinned the note can take it down.',
    onlyToday: 'today only',
    untilTomorrow: 'until tomorrow',
    until: (day: string) => `until ${day}`,
  },
} as const;

export const starsText = STARS_TEXT[locale];
